import template from './refreshButton.html';

const refreshButtonConfig = {
  template,
  bindings: {
    reload: '&'
  }
};

export default function (ngModule) {
  ngModule.component('refreshButton', refreshButtonConfig);
}
